module.exports = [
  {
    "name": "Afghanistan",
    "code": "AF"
  }, {
    "name": "Åland",
    "code": "AX"
  }, {
    "name": "Albanien",
    "code": "AL"
  }, {
    "name": "Algerien",
    "code": "DZ"
  }, {
    "name": "Amerikanisch-Samoa",
    "code": "AS"
  }, {
    "name": "Andorra",
    "code": "AD"
  }, {
    "name": "Angola",
    "code": "AO"
  }, {
    "name": "Anguilla",
    "code": "AI"
  }, {
    "name": "Antarktika",
    "code": "AQ"
  }, {
    "name": "Antigua und Barbuda",
    "code": "AG"
  }, {
    "name": "Argentinien",
    "code": "AR"
  }, {
    "name": "Armenien",
    "code": "AM"
  }, {
    "name": "Aruba",
    "code": "AW"
  }, {
    "name": "Australien",
    "code": "AU"
  }, {
    "name": "Österreich",
    "code": "AT"
  }, {
    "name": "Aserbaidschan",
    "code": "AZ"
  }, {
    "name": "Bahamas",
    "code": "BS"
  }, {
    "name": "Bahrain",
    "code": "BH"
  }, {
    "name": "Bangladesch",
    "code": "BD"
  }, {
    "name": "Barbados",
    "code": "BB"
  }, {
    "name": "Weißrussland",
    "code": "BY"
  }, {
    "name": "Belgien",
    "code": "BE"
  }, {
    "name": "Belize",
    "code": "BZ"
  }, {
    "name": "Benin",
    "code": "BJ"
  }, {
    "name": "Bermuda",
    "code": "BM"
  }, {
    "name": "Bhutan",
    "code": "BT"
  }, {
    "name": "Bolivien",
    "code": "BO"
  }, {
    "name": "Bonaire",
    "code": "BQ"
  }, {
    "name": "Bosnien und Herzegowina",
    "code": "BA"
  }, {
    "name": "Botswana",
    "code": "BW"
  }, {
    "name": "Bouvetinsel",
    "code": "BV"
  }, {
    "name": "Brasilien",
    "code": "BR"
  }, {
    "name": "Britisches Territorium im Indischen Ozean",
    "code": "IO"
  }, {
    "name": "Brunei Darussalam",
    "code": "BN"
  }, {
    "name": "Bulgarien",
    "code": "BG"
  }, {
    "name": "Burkina Faso",
    "code": "BF"
  }, {
    "name": "Burundi",
    "code": "BI"
  }, {
    "name": "Kambodscha",
    "code": "KH"
  }, {
    "name": "Kamerun",
    "code": "CM"
  }, {
    "name": "Kanada",
    "code": "CA"
  }, {
    "name": "Kap Verde",
    "code": "CV"
  }, {
    "name": "Kaimaninseln",
    "code": "KY"
  }, {
    "name": "Zentralafrikanische Republik",
    "code": "CF"
  }, {
    "name": "Tschad",
    "code": "TD"
  }, {
    "name": "Chile",
    "code": "CL"
  }, {
    "name": "China",
    "code": "CN"
  }, {
    "name": "Weihnachtsinsel",
    "code": "CX"
  }, {
    "name": "Kokosinseln",
    "code": "CC"
  }, {
    "name": "Kolumbien",
    "code": "CO"
  }, {
    "name": "Komoren",
    "code": "KM"
  }, {
    "name": "Republik Kongo",
    "code": "CG"
  }, {
    "name": "Kongo",
    "code": "CD"
  }, {
    "name": "Cookinseln",
    "code": "CK"
  }, {
    "name": "Costa Rica",
    "code": "CR"
  }, {
    "name": "Elfenbeinküste",
    "code": "CI"
  }, {
    "name": "Kroatien",
    "code": "HR"
  }, {
    "name": "Kuba",
    "code": "CU"
  }, {
    "name": "Curaçao",
    "code": "CW"
  }, {
    "name": "Zypern",
    "code": "CY"
  }, {
    "name": "Tschechische Republik",
    "code": "CZ"
  }, {
    "name": "Dänemark",
    "code": "DK"
  }, {
    "name": "Dschibuti",
    "code": "DJ"
  }, {
    "name": "Dominica",
    "code": "DM"
  }, {
    "name": "Dominikanische Republik",
    "code": "DO"
  }, {
    "name": "Ecuador",
    "code": "EC"
  }, {
    "name": "Ägypten",
    "code": "EG"
  }, {
    "name": "El Salvador",
    "code": "SV"
  }, {
    "name": "Äquatorialguinea",
    "code": "GQ"
  }, {
    "name": "Eritrea",
    "code": "ER"
  }, {
    "name": "Estland",
    "code": "EE"
  }, {
    "name": "Äthiopien",
    "code": "ET"
  }, {
    "name": "Falklandinseln",
    "code": "FK"
  }, {
    "name": "Färöer",
    "code": "FO"
  }, {
    "name": "Fidschi",
    "code": "FJ"
  }, {
    "name": "Finnland",
    "code": "FI"
  }, {
    "name": "Frankreich",
    "code": "FR"
  }, {
    "name": "Französisch-Guayana",
    "code": "GF"
  }, {
    "name": "Französisch-Polynesien",
    "code": "PF"
  }, {
    "name": "Französische Süd- und Antarktisgebiet",
    "code": "TF"
  }, {
    "name": "Gabun",
    "code": "GA"
  }, {
    "name": "Gambia",
    "code": "GM"
  }, {
    "name": "Georgien",
    "code": "GE"
  }, {
    "name": "Deutschland",
    "code": "DE"
  }, {
    "name": "Ghana",
    "code": "GH"
  }, {
    "name": "Gibraltar",
    "code": "GI"
  }, {
    "name": "Griechenland",
    "code": "GR"
  }, {
    "name": "Grönland",
    "code": "GL"
  }, {
    "name": "Grenada",
    "code": "GD"
  }, {
    "name": "Guadeloupe",
    "code": "GP"
  }, {
    "name": "Guam",
    "code": "GU"
  }, {
    "name": "Guatemala",
    "code": "GT"
  }, {
    "name": "Guernsey",
    "code": "GG"
  }, {
    "name": "Guinea",
    "code": "GN"
  }, {
    "name": "Guinea-Bissau",
    "code": "GW"
  }, {
    "name": "Guyana",
    "code": "GY"
  }, {
    "name": "Haiti",
    "code": "HT"
  }, {
    "name": "Heard und McDonaldinseln",
    "code": "HM"
  }, {
    "name": "Vatikanstadt",
    "code": "VA"
  }, {
    "name": "Honduras",
    "code": "HN"
  }, {
    "name": "Hongkong",
    "code": "HK"
  }, {
    "name": "Ungarn",
    "code": "HU"
  }, {
    "name": "Island",
    "code": "IS"
  }, {
    "name": "Indien",
    "code": "IN"
  }, {
    "name": "Indonesien",
    "code": "ID"
  }, {
    "name": "Iran",
    "code": "IR"
  }, {
    "name": "Irak",
    "code": "IQ"
  }, {
    "name": "Irland",
    "code": "IE"
  }, {
    "name": "Insel Man",
    "code": "IM"
  }, {
    "name": "Israel",
    "code": "IL"
  }, {
    "name": "Italien",
    "code": "IT"
  }, {
    "name": "Jamaika",
    "code": "JM"
  }, {
    "name": "Japan",
    "code": "JP"
  }, {
    "name": "Jersey",
    "code": "JE"
  }, {
    "name": "Jordanien",
    "code": "JO"
  }, {
    "name": "Kasachstan",
    "code": "KZ"
  }, {
    "name": "Kenia",
    "code": "KE"
  }, {
    "name": "Kiribati",
    "code": "KI"
  }, {
    "name": "Nordkorea",
    "code": "KP"
  }, {
    "name": "Südkorea",
    "code": "KR"
  }, {
    "name": "Kuwait",
    "code": "KW"
  }, {
    "name": "Kirgisistan",
    "code": "KG"
  }, {
    "name": "Laos",
    "code": "LA"
  }, {
    "name": "Lettland",
    "code": "LV"
  }, {
    "name": "Libanon",
    "code": "LB"
  }, {
    "name": "Lesotho",
    "code": "LS"
  }, {
    "name": "Liberia",
    "code": "LR"
  }, {
    "name": "Libyen",
    "code": "LY"
  }, {
    "name": "Liechtenstein",
    "code": "LI"
  }, {
    "name": "Litauen",
    "code": "LT"
  }, {
    "name": "Luxemburg",
    "code": "LU"
  }, {
    "name": "Macao",
    "code": "MO"
  }, {
    "name": "Mazedonien",
    "code": "MK"
  }, {
    "name": "Madagaskar",
    "code": "MG"
  }, {
    "name": "Malawi",
    "code": "MW"
  }, {
    "name": "Malaysia",
    "code": "MY"
  }, {
    "name": "Malediven",
    "code": "MV"
  }, {
    "name": "Mali",
    "code": "ML"
  }, {
    "name": "Malta",
    "code": "MT"
  }, {
    "name": "Marshallinseln",
    "code": "MH"
  }, {
    "name": "Martinique",
    "code": "MQ"
  }, {
    "name": "Mauretanien",
    "code": "MR"
  }, {
    "name": "Mauritius",
    "code": "MU"
  }, {
    "name": "Mayotte",
    "code": "YT"
  }, {
    "name": "Mexiko",
    "code": "MX"
  }, {
    "name": "Mikronesien",
    "code": "FM"
  }, {
    "name": "Moldawien",
    "code": "MD"
  }, {
    "name": "Monaco",
    "code": "MC"
  }, {
    "name": "Mongolei",
    "code": "MN"
  }, {
    "name": "Montenegro",
    "code": "ME"
  }, {
    "name": "Montserrat",
    "code": "MS"
  }, {
    "name": "Marokko",
    "code": "MA"
  }, {
    "name": "Mosambik",
    "code": "MZ"
  }, {
    "name": "Myanmar",
    "code": "MM"
  }, {
    "name": "Namibia",
    "code": "NA"
  }, {
    "name": "Nauru",
    "code": "NR"
  }, {
    "name": "Nepal",
    "code": "NP"
  }, {
    "name": "Niederlande",
    "code": "NL"
  }, {
    "name": "Neukaledonien",
    "code": "NC"
  }, {
    "name": "Neuseeland",
    "code": "NZ"
  }, {
    "name": "Nicaragua",
    "code": "NI"
  }, {
    "name": "Niger",
    "code": "NE"
  }, {
    "name": "Nigeria",
    "code": "NG"
  }, {
    "name": "Niue",
    "code": "NU"
  }, {
    "name": "Norfolkinsel",
    "code": "NF"
  }, {
    "name": "Nördliche Marianen",
    "code": "MP"
  }, {
    "name": "Norwegen",
    "code": "NO"
  }, {
    "name": "Oman",
    "code": "OM"
  }, {
    "name": "Pakistan",
    "code": "PK"
  }, {
    "name": "Palau",
    "code": "PW"
  }, {
    "name": "Staat Palästina",
    "code": "PS"
  }, {
    "name": "Panama",
    "code": "PA"
  }, {
    "name": "Papua-Neuguinea",
    "code": "PG"
  }, {
    "name": "Paraguay",
    "code": "PY"
  }, {
    "name": "Peru",
    "code": "PE"
  }, {
    "name": "Philippinen",
    "code": "PH"
  }, {
    "name": "Pitcairninseln",
    "code": "PN"
  }, {
    "name": "Polen",
    "code": "PL"
  }, {
    "name": "Portugal",
    "code": "PT"
  }, {
    "name": "Puerto Rico",
    "code": "PR"
  }, {
    "name": "Katar",
    "code": "QA"
  }, {
    "name": "Réunion",
    "code": "RE"
  }, {
    "name": "Rumänien",
    "code": "RO"
  }, {
    "name": "Russische Föderation",
    "code": "RU"
  }, {
    "name": "Rwanda",
    "code": "RW"
  }, {
    "name": "Saint Barthélemy",
    "code": "BL"
  }, {
    "name": "St. Helena",
    "code": "SH"
  }, {
    "name": "St. Kitts und Nevis",
    "code": "KN"
  }, {
    "name": "St. Lucia",
    "code": "LC"
  }, {
    "name": "Saint-Martin",
    "code": "MF"
  }, {
    "name": "Saint-Pierre und Miquelon",
    "code": "PM"
  }, {
    "name": "St. Vincent und die Grenadinen",
    "code": "VC"
  }, {
    "name": "Samoa",
    "code": "WS"
  }, {
    "name": "San Marino",
    "code": "SM"
  }, {
    "name": "São Tomé und Príncipe",
    "code": "ST"
  }, {
    "name": "Saudi-Arabien",
    "code": "SA"
  }, {
    "name": "Senegal",
    "code": "SN"
  }, {
    "name": "Serbien",
    "code": "RS"
  }, {
    "name": "Seychellen",
    "code": "SC"
  }, {
    "name": "Sierra Leone",
    "code": "SL"
  }, {
    "name": "Singapur",
    "code": "SG"
  }, {
    "name": "Sint Maarten",
    "code": "SX"
  }, {
    "name": "Slowakei",
    "code": "SK"
  }, {
    "name": "Slowenien",
    "code": "SI"
  }, {
    "name": "Salomonen",
    "code": "SB"
  }, {
    "name": "Somalia",
    "code": "SO"
  }, {
    "name": "Südafrika",
    "code": "ZA"
  }, {
    "name": "Südgeorgien und die Südlichen Sandwichinseln",
    "code": "GS"
  }, {
    "name": "Südsudan",
    "code": "SS"
  }, {
    "name": "Spanien",
    "code": "ES"
  }, {
    "name": "Sri Lanka",
    "code": "LK"
  }, {
    "name": "Sudan",
    "code": "SD"
  }, {
    "name": "Suriname",
    "code": "SR"
  }, {
    "name": "Svalbard und Jan Mayen",
    "code": "SJ"
  }, {
    "name": "Swasiland",
    "code": "SZ"
  }, {
    "name": "Schweden",
    "code": "SE"
  }, {
    "name": "Schweiz",
    "code": "CH"
  }, {
    "name": "Syrien, Arabische Republik",
    "code": "SY"
  }, {
    "name": "Taiwan",
    "code": "TW"
  }, {
    "name": "Tadschikistan",
    "code": "TJ"
  }, {
    "name": "Tansania, Vereinigte Republik",
    "code": "TZ"
  }, {
    "name": "Thailand",
    "code": "TH"
  }, {
    "name": "Osttimor",
    "code": "TL"
  }, {
    "name": "Togo",
    "code": "TG"
  }, {
    "name": "Tokelau",
    "code": "TK"
  }, {
    "name": "Tonga",
    "code": "TO"
  }, {
    "name": "Trinidad und Tobago",
    "code": "TT"
  }, {
    "name": "Tunesien",
    "code": "TN"
  }, {
    "name": "Türkei",
    "code": "TR"
  }, {
    "name": "Turkmenistan",
    "code": "TM"
  }, {
    "name": "Turks und Caicosinseln",
    "code": "TC"
  }, {
    "name": "Tuvalu",
    "code": "TV"
  }, {
    "name": "Uganda",
    "code": "UG"
  }, {
    "name": "Ukraine",
    "code": "UA"
  }, {
    "name": "Vereinigte Arabische Emirate",
    "code": "AE"
  }, {
    "name": "Vereinigtes Königreich",
    "code": "GB"
  }, {
    "name": "Vereinigte Staaten von Amerika",
    "code": "US"
  }, {
    "name": "United States Minor Outlying Islands",
    "code": "UM"
  }, {
    "name": "Uruguay",
    "code": "UY"
  }, {
    "name": "Uzbekistan",
    "code": "UZ"
  }, {
    "name": "Vanuatu",
    "code": "VU"
  }, {
    "name": "Venezuela",
    "code": "VE"
  }, {
    "name": "Vietnam",
    "code": "VN"
  }, {
    "name": "Britische Jungferninseln",
    "code": "VG"
  }, {
    "name": "Amerikanische Jungferninseln",
    "code": "VI"
  }, {
    "name": "Wallis und Futuna",
    "code": "WF"
  }, {
    "name": "Westsahara",
    "code": "EH"
  }, {
    "name": "Jemen",
    "code": "YE"
  }, {
    "name": "Sambia",
    "code": "ZM"
  }, {
    "name": "Simbabwe",
    "code": "ZW"
  }
]
